import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { ListMedicalSpecialtyResponse } from '../../responses/digital-prompt-service/list-medical-specialty.response';

@Injectable({
  providedIn: 'root'
})
export class MedicalSpecialtyPatientCenterService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient,) {
    super();
  }
  
  public listMedicalSpecialty(): Observable<ListMedicalSpecialtyResponse> {
    
    let uri = 'MedicalSpecialtyPatientCenter/getAll'
    
    return this.httpClient.get<ListMedicalSpecialtyResponse>(environment.urlApiDigitalPrompt + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
    
    